
import { ModalForm } from "@/components/ModalForm";
import { ContactFormFields } from "./contacts/ContactFormFields";
import { JobsSelection } from "./contacts/JobsSelection";
import { useContactForm } from "@/hooks/companies/useContactForm";

interface AddContactFormProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  companyId: string;
}

export const AddContactForm = ({ 
  isOpen, 
  onClose, 
  onSubmit,
  companyId 
}: AddContactFormProps) => {
  const {
    formData,
    isSubmitting,
    selectedJobs,
    setSelectedJobs,
    handleChange,
    submitForm
  } = useContactForm({
    companyId,
    onSuccess: onSubmit
  });
  
  return (
    <ModalForm
      title="Add Contact"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={submitForm}
      submitText="Add Contact"
      submitDisabled={isSubmitting}
    >
      <div className="space-y-4">
        <ContactFormFields 
          formData={formData} 
          onChange={handleChange} 
          disabled={isSubmitting}
        />
        
        <JobsSelection 
          companyId={companyId}
          selectedJobs={selectedJobs}
          onJobsChange={setSelectedJobs}
          disabled={isSubmitting}
        />
      </div>
    </ModalForm>
  );
};
